import styled from "styled-components";
import { Text } from "../Text/Text.js";
import { StyleBadgeProps } from "./Badge.types.js";

export const CountText = styled(Text)`
    min-width: ${({ theme }) => theme.rem(0.875)};
    text-align: center;
    line-height: ${({ theme }) => theme.rem(0.875)};
`;

export const StyledSpan = styled.span<StyleBadgeProps>`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    color: ${(props) =>
        props.color === "dark" ? props.theme.grayscale.white : props.theme.colors[props.color][props.variant === "dark" ? 10 : 100]};
    background-color: ${(props) => {
        if (props.color === "dark") {
            return props.theme.grayscale.white;
        }
        return props.variant === "dark" ? props.theme.colors[props.color][100] : props.theme.colors[props.color][10];
    }};
    border-radius: ${({ hasContent, theme }) => (hasContent ? theme.radius.xs : theme.radius.round)};
    padding: ${(props) => (props.standalone ? `${props.theme.spacing[16]}` : "")};
    top: ${({ standalone, yOffset }) => (standalone ? "" : yOffset)};
    left: ${({ standalone, xOffset }) => (standalone ? "" : `calc(100% + ${xOffset})`)};
    padding: ${(props) => (props.standalone ? `` : `${props.theme.spacing[4]}`)};
    min-width: ${(props) => `${props.theme.spacing[16]}`};
    min-height: ${(props) => `${props.theme.spacing[16]}`};
    gap: ${(props) => `${props.theme.spacing[4]}`};
    & svg {
        width: ${({ theme }) => theme.rem(0.75)};
        height: ${({ theme }) => theme.rem(0.75)};
    }
`;

export const StyledBadge = styled.div`
    width: 100%;
    display: inline-flex;
    align-items: flex-start;
    justify-content: flex-start;
    position: relative;
    cursor: default;
`;
